import React, { useEffect, useState } from "react";
import Menu from "../Menu";
import Footer from "../footer";
import MetaTags from "react-meta-tags";
import ReactGA from "react-ga";
import { getRulesInfo } from "../api/main";
import parse from "html-react-parser";
export default function Rules({ hideFooterAndHeader }) {
  const [info, setInfo] = useState("");
  const [aboutUa, setaboutUa] = useState("");

  const getData = async () => {
    let data = await getRulesInfo();
    if (data.data) {
      setInfo(data.data.info.replaceAll("%Website%", window.location.origin));

      {
      }
      let tempData = data.data.about_ua.replaceAll("%CompanyName%", "ТОВ Споживчий центр");
      // tempData.replaceAll(`href="/registration/step1/"`, `href="/registration-step1-new2"`);

      let tempData2 = tempData.replaceAll("/registration/step1/", "/registration-step1-new2");
      console.log(`object`, tempData.includes(`/registration/step1/`));
      setaboutUa(tempData2.replaceAll("%Website%", "https://sgroshi.com.ua"));
    }
  };

  function returnModifiedDOM() {
    const kostylDomElementsLinks = document.querySelectorAll(".side_site");
    kostylDomElementsLinks.forEach((element, index) => {
      const parentNodeTest = element.parentNode;
      const nodeNew = document.createElement("div");
      nodeNew.style.display = "contents";
      const nodetoInsert = `<span id="pdf_${index}" style="text-decoration: underline; cursor: pointer; color: #0056a8;">${element.innerHTML}</span>
			<div class="modalPdfLink" id="pdf_${index}_modal" style="display: flex; z-index: 500; position: fixed; width: 100%; height: 100%; left: 0px; top: 0px; justify-content: center; align-items: center; background: rgba(0, 0, 0, 0.4)"><span id="modal_closed_${index}" style="position: absolute; cursor: pointer; width: 30px; height: 30px; font-size: 20px; display: flex; border-radius: 20px; background: #0056a8; right: 10px; top: 10px; text-align: center; justify-content: center; align-items: center; font-weight: 900; border: 3px solid #fff; color: white;">X</span>
			<div class="modal_bg" style="display: flex; justify-content: center; max-width: 1200px; max-height: 850px; width: 95%; height: 90%;">
			<div class="content_wrapper_modal" style="width: 100%; height: 100%;"><embed frameborder="0" src="${element.href}" style="width: 100%; height: 100%;"></embed></div>
			</div>
			</div>`;
      nodeNew.insertAdjacentHTML("afterbegin", nodetoInsert);
      parentNodeTest.appendChild(nodeNew);
      parentNodeTest.replaceChild(nodeNew, element);
    });
  }
  // replacedNode = parentNode.replaceChild(newChild, oldChild);

  useEffect(() => {
    getData();
  }, []);
  // useEffect(() => {
  //   if (aboutUa) {
  //     // window.addEventListener("click", modalPdfLogic);
  //     // returnModifiedDOM();
  //   }
  // }, [aboutUa]);

  function modalPdfLogic(e) {
    //ищем пдф айдишник .Если это спан по которому жмякнули то  ищем див под ним .Он display none

    if (e.target.id.includes("pdf_")) {
      //id div a такое же,только +   _modal
      const modalWithPdf = document.getElementById(`${e.target.id}_modal`);
      if (modalWithPdf) {
        modalWithPdf.classList.toggle("modalPdfLink");
      }
    }
    if (e.target.id.includes("modal_close")) {
      const closeButton = document.getElementById(e.target.id);
      closeButton.parentNode.classList.toggle("modalPdfLink");
    }
  }

  return (
    <div>
      <MetaTags>
        <title>ДовгоГроші – Кредит на картку онлайн до 50 000 грн | Ліцензія НБУ</title>
        <meta
          name="description"
          content="Надійний кредит онлайн ДовгоГроші (ТОВ «Споживчий Центр») пропонує прозорі умови. Рішення за 15 хвилин. Дізнайтесь більше та подайте заявку!"
        />
      </MetaTags>
      {!hideFooterAndHeader && <Menu />}
      <div className="main-block">
        <h1 className="header_rules">Загальна iнформацiя про компанiю</h1>
        <div className="main-block-info padding_rules">
          <div className="main-block-info-left"></div>
          <div className="main-block-info-right">
            {info && parse(info)}
            {aboutUa && parse(aboutUa)}
          </div>
        </div>
      </div>
      {ReactGA.pageview("/rules")}
      {!hideFooterAndHeader && <Footer />}
    </div>
  );
}



// WEBPACK FOOTER //
// src/pages/rules.js